import { Effect } from "../../Materials/effect";
var name = 'morphTargetsVertex';
var shader = "#ifdef MORPHTARGETS\npositionUpdated+=(position{X}-position)*morphTargetInfluences[{X}];\n#ifdef MORPHTARGETS_NORMAL\nnormalUpdated+=(normal{X}-normal)*morphTargetInfluences[{X}];\n#endif\n#ifdef MORPHTARGETS_TANGENT\ntangentUpdated.xyz+=(tangent{X}-tangent.xyz)*morphTargetInfluences[{X}];\n#endif\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var morphTargetsVertex = { name: name, shader: shader };
//# sourceMappingURL=morphTargetsVertex.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Shaders/ShadersInclude/morphTargetsVertex.js
// module id = q5gh
// module chunks = 0